var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"right":"","color":_vm.color,"timeout":2000},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('v-btn',{attrs:{"text":""},nativeOn:{"click":function($event){_vm.show = false}}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }